import { Badge } from "@/components/ui/badge";

export const FlagBadge = ({ level }: { level: number | null }) => {
  if (!level || !Number.isFinite(level)) return <span className="text-gray-700">No Risk</span>;
  if (level === 2) return <Badge className="bg-yellow-100 text-yellow-800 hover:bg-yellow-200">T2</Badge>;
  if (level === 1) return <Badge className="bg-red-100 text-red-800 hover:bg-red-200">T1</Badge>;
  return <Badge className="bg-blue-100 text-blue-800 hover:bg-blue-200">T{level}</Badge>;
};

export const FlagBadges = ({ levels }: { levels: number[] }) => {
  if (!levels.length) return <span className="text-sm text-tertiary">No Risk</span>;
  return (
    <div className="text-sm text-tertiary flex  gap-1">
      {levels.map((tier) => (
        <FlagBadge level={tier} key={tier} />
      ))}
    </div>
  );
};
